export enum BookedState {
  ALL = 'ALL',
  BOOKED = 'BOOKED',
  UNBOOKED = 'UNBOOKED',
}
